import { Component, OnInit } from '@angular/core';
import { Prefrence } from './model/interfaces';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';
import { HttpErrorResponse } from '@angular/common/http';
 import { PdfGeneratorServiceService } from 'src/app/shared/pdf-generator-service.service';

@Component({
  selector: 'app-pierchipraga',
  templateUrl: './pierchipraga.component.html',
  styleUrls: ['./pierchipraga.component.css']
})
export class PIERCHIPRAGAComponent implements OnInit {
  preference: Prefrence | null = null;
  email: string | undefined = '';
  tollfreeNo: string | undefined | null = '';
  faxNo: string | undefined | null = '';
  errorMessageIntialData: string = '';
  mailingAddress: string = '';
  dropingAddress: string ='';
  emailTo: string = '';
  logo: any;
  applicationPdf: any;
  renewalApplicationPdf: any;
  cmoFaqPdf :any;
  mailingOffice: string='';
  mailingAddressLine: string='';
  mailingAddressLine2: string='';
  mailingCityStateZip: string='';
  empInsuranceDataPdf:any;
  documentChecklistPdf: any;
  authorizationFormPdf: any;
  faqFormPdf: any;
  consentForm: any;
  benefitMonth?: string;
  eobYear?:number;
  benefitYear?:number;
  thirtyPlusDate?: string | null;


  constructor(
    private dataService: DataService,
    private logger: LoggerService,
    private pdfService: PdfGeneratorServiceService
  ) {}

  ngOnInit(): void {
    this.logo = 'app/module/pierchipraga/assets/img/GA_Logo.png';
    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;

        this.faxNo = ValidationService.formatPhoneNumber(
          this.preference.preferenceValues?.['FAX_NUM']
        );
        this.applicationPdf = this.preference.paperApplication;
        this.renewalApplicationPdf = this.preference.renewalApplication;
        this.cmoFaqPdf = this.preference.cmoFaq;
        this.empInsuranceDataPdf = this.preference.empInsuranceData;
        this.documentChecklistPdf = this.preference.documentChecklist;
        this.authorizationFormPdf = this.preference.authorizationForm;
        this.faqFormPdf = this.preference.faqForm;
        this.consentForm = this.preference.consentForm;
        this.eobYear = this.preference.eobYear;
        this.benefitYear = this.preference.benefitYear;
        this.benefitMonth = this.preference.benefitMonth;
        this.tollfreeNo = ValidationService.formatPhoneNumber(this.preference.preferenceValues?.['TOLL_FREE_NUM']);

        this.email = this.preference.preferenceValues?.['EMAIL_ID'];
        this.emailTo = 'mailto:' + this.email;
        this.mailingAddress =
          '' +
          this.preference.preferenceValues?.['STATE_PROGRAM'] +
          ', ' +
          this.preference.preferenceValues?.['ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['ADDRESS2_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['CITY_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['ZIP_CODE'];

          this.mailingOffice = '' + this.preference.preferenceValues?.['STATE_PROGRAM'];
          this.mailingAddressLine = '' + this.preference.preferenceValues?.['ADDRESS1_TXT'];
          this.mailingAddressLine2 = '' + this.preference.preferenceValues?.['ADDRESS2_TXT'];
          this.mailingCityStateZip = '' + this.preference.preferenceValues?.['CITY_TXT'] +
          ', ' + this.preference.preferenceValues?.['STATE_CD'] +
          ' ' + this.preference.preferenceValues?.['ZIP_CODE'];

        this.dropingAddress =
        '' +
          this.preference.preferenceValues?.['DROPOFF_OFFICE'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS1_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_ADDRESS2_TXT'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_CITY'] +
          ', ' +
          this.preference.preferenceValues?.['DROPOFF_STATE_CD'] +
          ' ' +
          this.preference.preferenceValues?.['DROPOFF_ZIPCD'];


      },
      error: (err: HttpErrorResponse) => {
        this.logger.logMsg(err.error);
        const msg = 'Unable to get the Preference details: ' + err.message;
        this.errorMessageIntialData = msg;
      },
    });
  }

  pdfData(pdf: any, name: string){
    this.pdfService.generatePdf(pdf, name);
  }
 

}

